/* eslint-disable @typescript-eslint/no-explicit-any */

export function toQueryParam(options: Record<string, any>): string {
  const params = new URLSearchParams();

  Object.entries(options).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    params.append(key, String(value));
  });

  return params.toString();
}

export function withQuery(path: string, options: Record<string, any>): string {
  const query = toQueryParam(options);
  return query ? `${path}?${query}` : path;
}
